export default {
  startEvent: 'load', // 監聽網頁讀取事件 DOMContentLoaded(較快), load(較慢)
  once: false, // 出現一次
  mirror: false, // 出現一次
  delay: 0,
  duration: 1000,
  easing: 'ease-in-out-quint'
}
